/* EVMT auto-variant-select
 * When a customer changes one product option, snap the remaining options to
 * the nearest AVAILABLE variant so the page never sits on an incomplete or
 * unavailable combination (wrong image + "Unavailable" button).
 *
 * Works with Dawn's <variant-selects>: runs in the capture phase so the
 * corrected option state is already in place when Dawn's own change handler
 * reads it — one section render, no event loops.
 */
(function () {
  'use strict';

  var productDataPromise = null;

  function getProductData() {
    if (!productDataPromise) {
      var m = window.location.pathname.match(/\/products\/[^\/]+/);
      if (!m) return Promise.reject(new Error('not a product page'));
      productDataPromise = fetch(m[0] + '.js').then(function (r) { return r.json(); });
    }
    return productDataPromise;
  }

  // Option groups in DOM order (radio fieldsets and/or dropdowns)
  function getGroups(root) {
    var groups = [];
    root.querySelectorAll('fieldset').forEach(function (fs) {
      var radios = fs.querySelectorAll('input[type="radio"]');
      if (radios.length) groups.push({ type: 'radio', inputs: radios });
    });
    root.querySelectorAll('select.select__select').forEach(function (sel) {
      groups.push({ type: 'select', el: sel });
    });
    return groups;
  }

  function groupValue(g) {
    if (g.type === 'select') return g.el.value;
    var checked = Array.prototype.find.call(g.inputs, function (i) { return i.checked; });
    return checked ? checked.value : null;
  }

  function setGroupValue(g, value) {
    if (g.type === 'select') {
      if (g.el.value !== value) g.el.value = value;
      return;
    }
    Array.prototype.forEach.call(g.inputs, function (i) {
      i.checked = i.value === value;
    });
  }

  function variantOptions(v) { return [v.option1, v.option2, v.option3]; }

  function pickBest(variants, changedIdx, changedValue, current) {
    var exact = variants.find(function (v) {
      var o = variantOptions(v);
      return current.every(function (c, i) { return c === null || o[i] === c; });
    });
    if (exact && exact.available) return null; // already valid — leave alone

    var candidates = variants.filter(function (v) {
      return v.available && variantOptions(v)[changedIdx] === changedValue;
    });
    if (!candidates.length) return null;

    var best = null, bestScore = -1;
    candidates.forEach(function (v) {
      var o = variantOptions(v), score = 0;
      current.forEach(function (c, i) {
        if (i !== changedIdx && c !== null && o[i] === c) score += Math.pow(10, 2 - i);
      });
      if (score > bestScore) { bestScore = score; best = v; }
    });
    return best;
  }

  document.addEventListener('change', function (e) {
    var root = e.target && e.target.closest && e.target.closest('variant-selects, variant-radios');
    if (!root) return;

    var groups = getGroups(root);
    if (groups.length < 2) return;

    var changedIdx = -1;
    groups.forEach(function (g, i) {
      var hit = g.type === 'select' ? g.el === e.target
        : Array.prototype.indexOf.call(g.inputs, e.target) !== -1;
      if (hit) changedIdx = i;
    });
    if (changedIdx === -1) return;

    if (!window.__evmtProductData) {
      getProductData().then(function (d) {
        window.__evmtProductData = d;
        // re-dispatch once data is ready so the fix applies on first click too
        var evt = new Event('change', { bubbles: true });
        e.target.dispatchEvent(evt);
      });
      return;
    }
    var data = window.__evmtProductData;

    var current = groups.map(groupValue);
    var best = pickBest(data.variants, changedIdx, current[changedIdx], current);
    if (!best) return;

    var opts = variantOptions(best);
    groups.forEach(function (g, i) {
      if (i !== changedIdx && opts[i] != null) setGroupValue(g, opts[i]);
    });
  }, true); // capture: runs before Dawn's own change handler

  // warm the product data cache on page load
  if (/\/products\//.test(window.location.pathname)) {
    getProductData().then(function (d) { window.__evmtProductData = d; }).catch(function () {});
  }
})();
